module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium.38d0a2a1.woff2";